import { Locale as DateFnsLocale } from "date-fns";
import { de, enGB } from "date-fns/locale";
import { LxLocale } from "../../Types/LxLocale";

type FormatRelativeTokens =
  | "lastWeek"
  | "yesterday"
  | "today"
  | "tomorrow"
  | "nextWeek"
  | "other";

const LOCALE_DE_DE: DateFnsLocale = {
  ...de,
  formatRelative: (token: FormatRelativeTokens) => {
    const tokens = {
      lastWeek: "EE dd.MM.y, p",
      yesterday: "'Gestern', p",
      today: "'Heute', p",
      tomorrow: "'Morgen', p",
      nextWeek: "EE dd.MM.y, p",
      other: "EE dd.MM.y, p",
    };
    return tokens[token] || tokens.other;
  },
};

const LOCALE_EN_GB: DateFnsLocale = {
  ...enGB,
  formatRelative: (token: FormatRelativeTokens) => {
    const tokens = {
      lastWeek: "EE dd.MM.y, p",
      yesterday: "'Yesterday', p",
      today: "'Today', p",
      tomorrow: "'Tomorrow', p",
      nextWeek: "EE dd.MM.y, p",
      other: "EE dd.MM.y, p",
    };
    return tokens[token] || tokens.other;
  },
};

const locales: { [key in LxLocale]: Locale } = {
  "de-DE": LOCALE_DE_DE,
  "en-GB": LOCALE_EN_GB,
};

// Internal
export function lxI18NDateFnLocale(locale: LxLocale): DateFnsLocale {
  return locales[locale];
}
